import { FC, useMemo } from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames/bind';

interface IProps {
    checked?: boolean;
    onClick?: () => void;
    large?: boolean;
    small?: boolean;
    className?: string;
    disabled?: boolean;
    variant?: 'gold' | 'dark' | 'red';
}

const cx = classNames.bind(styles);
const Radio: FC<IProps> = ({
    large,
    disabled,
    small,
    checked,
    onClick,
    className,
    variant = 'gold'
}) => {
    const rootStyles = useMemo(
        () =>
            cx([
                styles.root,
                { isChecked: checked, isDisabled: disabled, large, small },
                variant,
                className
            ]),
        [checked, disabled, className, large, small, variant]
    );

    return (
        <label className={rootStyles} onChange={onClick}>
            <span>
                <i />
            </span>
            <input type="radio" onChange={() => {}} disabled={disabled} checked={checked} />
        </label>
    );
};

export default Radio;
